module.exports = __webpack_public_path__ + "static/media/GreatVibes-Regular.c1c92d0c.ttf";